<template>
  <div class="report">
    <tips class="report-tip">
      <div class="report-tip__line"> 1. 如果在以下没有发现“对应的店铺，销售区域或国家站点”，请 <span class="report-tip__line--switch" @click="goStoreSetting">点击此处</span> 到“店铺设置页面”进行添加或修改设置； </div>
      <div class="report-tip__line"> 2. 由于亚马逊店铺“不同的销售区域”的货币，汇率或税务等各不相同，亚马逊店铺后台提供不同销售区域的独立数据报告，因此根据以下本系统设置的格式分别上传即可； </div>
      <div class="report-tip__line"> 3. 在亚马逊店铺后台下载保存数据报告时，建议按“店铺名-序号-(国家名)”的格式有规律地编号命名，例如：店铺名-1-美，店铺名-1-加，店铺名-1-墨，店铺名-2，店铺名-3..., 然后一 一对应上传，减少出错！ </div>
      <div class="report-tip__line"> 4. 由于目前统计量庞大，汇总统计可能遇上排队等待处理的情况（用户可以稍后查看“运营/在售商品与店铺利润核算”目录页里的"更新时间"确认汇总统计的完成状况); </div>
    </tips>
    <progressBar
      class="report-progress"
      :arr="progressData"
      :activeIndex="progressActiveIndex"></progressBar>
    <div class="report-top">
      <div class="report-top__title">上传汇总数据报告</div>
      <div class="report-top__subtitle">(备注: 根据大量会员的使用测试，熟练操作后，每月下载及上传"1店1区域销售"的数据报告及执行汇总统计只需花费约15分钟，“多店多区域销售”花费的时间将如此类推!)</div>
    </div>
    <div class="report-date">
      <div>
        <div class="report-module__text">选择汇总日期:</div>
        <el-select size="mini" v-model="summaryDataValue">
          <el-option v-for="(item, index) in summaryDataArray" :label="item" :key="index" :value="index"></el-option>
        </el-select>
      </div>
      <div class="report__btn" @click="openImgDialog">亚马逊数据报告下载指引</div>
    </div>
    <div class="report-store">
      <div class="report-module__text">
        选择店铺:
        <span class="report-module__text--tip" @click="goShopSettingPage">(注: 可在"设置/店铺及费用设置"目录页添加店铺)</span>
      </div>
      <div class="report-store-list">
        <div class="report-store-list__item"
          :class="{'report-store-list__item--select': index == selectStoreIndex}"
          @click="selectStoreIndex = index"
          v-for="(item, index) in storeData" :key="item.id">{{ item.storeName }}</div>
      </div>
    </div>
    <div class="report-file">
      <div class="report-file__list" v-if="reportData[selectAreaIndex]">
        <div class="report-module" v-for="item in reportTopInput" :key="item.data">
          <div class="report-module__text">
            <span class="report-module__text--star" v-if="item.isRequired">*</span>
            {{ item.name }}:
          </div>
          <div class="report-module__input">
            <div class="report-module__input__name">
              <template v-if="item.data == 'collectionData'">{{ storeData[selectStoreIndex].configMap.foreignExchangeCollectionAgency }}</template>
              <template v-else>blance</template>
            </div>
            <el-input size="mini" disabled v-model="reportData[selectAreaIndex][item.data]"></el-input>
            <div class="report-module__btn">
              上传
              <input type="file" name="" id="" class="report-module__btn__input" @change="uploadFile($event, item.data, item.fileType)">
            </div>
          </div>
        </div>
      </div>
      <div class="report-area">
        <div class="report-module__text">
          选择区域:
          <span class="report-module__text--tip" @click="goShopSettingPage">(注: 可在"设置/店铺及费用设置"目录页内添加区域)</span>
        </div>
        <div class="report-area-list">
          <div class="report-area-list__item"
            :class="{'report-area-list__item--select': index == selectAreaIndex}"
            @click="selectAreaIndex = index"
            v-for="(item, index) in areaList" :key="index">{{ index }}</div>
        </div>
      </div>
      <div class="report-file__list">
        <div class="report-module" v-for="item in reportAreaInput" :key="item.data">
          <div class="report-module__text">
            <span class="report-module__text--star" v-if="item.isRequired">*</span>
            {{ item.name }}:
            <span class="report-module__text--tips">{{ item.tips }}</span>
          </div>
          <div class="report-module__input report-module__input--area" v-for="area in areaList[selectAreaIndex]" :key="area.id">
            <div class="report-module__input__name">{{ area.name }}</div>
            <el-input size="mini" disabled v-model="reportData[selectAreaIndex][item.data][area.id]"></el-input>
            <div class="report-module__btn">
              上传
              <input type="file" name="" id="" class="report-module__btn__input" @change="uploadFile($event, item.data, item.fileType, area.id)">
            </div>
          </div>
        </div>
      </div>
      <div class="report-file__list">
        <div class="report-module">
          <div class="report-module" v-for="item in reportLeftInput" :key="item.data">
            <div class="report-module__text">
              <span class="report-module__text--star" v-if="item.isRequired">*</span>
              {{ item.name }}:
              <span class="report-module__text--tips">{{ item.tips }}</span>
            </div>
            <div class="report-module__input report-module__input--normal">
              <el-input size="mini" disabled  v-model="reportData[selectAreaIndex][item.data]"></el-input>
              <div class="report-module__btn">
                上传
                <input type="file" name="" id="" class="report-module__btn__input" @change="uploadFile($event, item.data, item.fileType)">
              </div>
            </div>
          </div>
        </div>
        <div class="report-module">
          <div class="report-module" v-for="item in reportRightInput" :key="item.data">
            <div class="report-module__text">
              <span class="report-module__text--star" v-if="item.isRequired">*</span>
              {{ item.name }}:
              <span class="report-module__text--tips">{{ item.tips }}</span>
            </div>
            <div class="report-module__input report-module__input--normal">
              <el-input size="mini" disabled  v-model="reportData[selectAreaIndex][item.data]"></el-input>
              <div class="report-module__btn">
                上传
                <input type="file" name="" id="" class="report-module__btn__input" @change="uploadFile($event, item.data, item.fileType)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="report-bottom">
      <div class="report__btn">马上汇总统计</div>
    </div>
    <Dialog :show="imgDialogShow" @cancel="imgDialogShow = false">
      <img src="../../../../assets/img/reportDownload.jpg" alt="" class="report-dialog__img">
    </Dialog>
  </div>
</template>

<script>
import { BoardInputNewModule, ReportUpload } from './class'
import { getAreaAndCountry } from '../shopExpenseSettings/class'
import tips from '../common/tips.vue';
import progressBar from 'components/common/progressBar';
import UserAxios from 'service/user'
import DefaultAxios from 'service/default'
import Dialog from 'components/common/Dialog'
export default {
  name: 'uploadSummaryReport',
  components: {
    progressBar, tips, Dialog
  },
  data(){
    return {
      /**进度条数据 */
      progressData: BoardInputNewModule.NEWPROGRESSARRAY(),
      progressActiveIndex: 1,
      /**汇总日期 */
      summaryDataValue: null,
      summaryDataArray: [],
      /**店铺数据 */
      storeData: [],
      selectStoreIndex: 0,
      /**区域数据 */
      selectAreaIndex: null,
      /**报告输入框 */
      reportTopInput: BoardInputNewModule.NEWTOPFILEINPUT(),
      reportAreaInput: BoardInputNewModule.NEWAREAFILEINPUT(),
      reportLeftInput: BoardInputNewModule.NEWLEFTFILEINPUT(),
      reportRightInput: BoardInputNewModule.NEWRIGHTFILEINPUT(),
      /**报告数据 */
      reportData: {},
      /**报告下载指引 */
      imgDialogShow: false
    }
  },
  methods:{
    /**切换店铺设置页面 */
    goStoreSetting(){
      this.$emit('go', {
        id: 'shopExpenseSettings',
        name: '店铺及费用设置',
      })
    },
    /**导入数据 */
    importData(array){
      let startTime, endTime
      return array.map((object, index) => {
        endTime = new Date(object).Format('yyyy-MM-dd')
        if(index === 0){
          startTime = new Date(array[array.length - 1] + 24*60*60*1000).Format('yyyy-MM-dd')
        }else{
          startTime = new Date(array[index - 1] + 24*60*60*1000).Format('yyyy-MM-dd')
        }
        return startTime + ' - ' + endTime
      })
    },
    /**获取已设置的汇总日期 */
    async getSetSummaryTime(){
      let res = await UserAxios.getSummaryDate()
      if(res.data.code !== 1){
        this.$message.error(res.data.info)
        return;
      }
      let data = res.data.info
      this.summaryDataArray = this.importData(data)
    },
    /**切换至店铺设置页面 */
    goShopSettingPage(){
      this.$emit('go', {
        id: 'shopExpenseSettings',
        name: '店铺及费用设置',
      })
    },
    /**上传报告 */
    async uploadFile(event, data, fileType, id){
      let file = event.target.files
      let res = await DefaultAxios.uploadFile(file, fileType)
      if(res.data.code != 1){
        this.$message.error(res.data.info)
        return
      }
      if(id){
        this.reportData[this.selectAreaIndex][data][id] = res.data.info.fileId
      }else{
        this.reportData[this.selectAreaIndex][data] = res.data.info.fileId
      }
      console.log(file, data, fileType, id);
    },
    /**打开报告下载指引 */
    openImgDialog(){
      this.imgDialogShow = true
    }
  },
  computed:{
    storeList(){
      return JSON.stringify(this.$store.state.storeList)
    },
    areaList(){
      let array = this.storeData[this.selectStoreIndex].configMap.financeFees
      let areaList = getAreaAndCountry(array)
      let result = {}
      areaList.map(object => {
        this.reportData[object.areaName] = new ReportUpload()
        result[object.areaName] = areaList.filter(obj => {
          if(obj.areaName == object.areaName) return obj.country
        }).map(obj => obj.country)
        if(!this.selectAreaIndex){
          this.selectAreaIndex = Object.keys(result)[0]
        }
      })
      return result
    }
  },
  watch:{
    storeList: {
      immediate: true,
      handler(newVal){
        this.storeData.splice(0, this.storeData.length)
        let arr = JSON.parse(newVal)
        arr.map(obj => this.storeData.push(obj))
      }
    },
  },
  created(){
    this.getSetSummaryTime()
  }
}
</script>

<style lang="scss" scoped>
.report{
  width: 1800px;
  &-tip{
    &__line{
      &--switch{
        color: #00a0c7;
        text-decoration: underline;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
  }
  &-progress{
    margin: 5px 0;
  }
  &-top{
    display: flex;
    align-items: end;
    &__title{
      font-size: 16px;
      font-weight: bold;
      color: black;
    }
    &__subtitle{
      color: #fca605;
      font-size: 12px;
      font-weight: normal;
    }
  }
  &-date{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 50px;
    ::v-deep{
      .el-input__inner{
        width: 500px;
      }
    }
  }
  &-store{
    &-list{
      display: flex;
      border-bottom: 2px solid #eeeeee;
      &__item{
        width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        padding: 8px 20px;
        margin-right: 5px;
        background: #F7F7F7;
        border-radius: 5px 5px 0 0;
        border: 1px solid #DCDFE6;
        border-bottom: 0px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
        &--select{
          color: white;
          background: #00a0c7;
          border-color: #00a0c7;
          &:hover{
            cursor: default;
            opacity: 1;
          }
        }
      }
    }
  }
  &-area{
    margin: 10px 0;
    &-list{
      display: flex;
      border-bottom: 2px solid #eeeeee;
      &__item{
        width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        padding: 8px 20px;
        margin-right: 5px;
        background: #F7F7F7;
        border-radius: 5px 5px 0 0;
        border: 1px solid #DCDFE6;
        border-bottom: 0px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
        &--select{
          color: white;
          background: #00a0c7;
          border-color: #00a0c7;
          &:hover{
            cursor: default;
            opacity: 1;
          }
        }
      }
    }
  }
  &-file{
    margin: 0 50px;
    &__list{
      display: flex;
      justify-content: space-between;
    }
  }
  &-module{
    &__text{
      line-height: 25px;
      &--star{
        color: red;
      }
      &--tip{
        color: #00a0c7;
        &:hover{
          cursor: pointer;
          opacity: .8;
          text-decoration: underline;
        }
      }
      &--tips{
        color: #00a0c7;
      }
    }
    &__input{
      display: flex;
      justify-content: start;
      align-items: center;
      line-height: 26px;
      &__name{
        border: 1px solid #DCDFE6;
        border-right: 0;
        width: 80px;
        text-align: center;
        background-color: #F5F7FA;
        color: #909399;
        font-size: 12px;
      }
      ::v-deep{
        .el-input{
          width: 600px;
        }
        .el-input__inner{
          width: 600px;
        }
      }
      &--area{
        margin-bottom: 10px;
        ::v-deep{
          .el-input{
            width: 380px;
          }
          .el-input__inner{
            width: 380px;
          }
        }
      }
      &--normal{
        ::v-deep{
          .el-input{
            width: 700px;
          }
          .el-input__inner{
            width: 700px;
          }
        }
      }
    }
    &__btn{
      position: relative;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      text-align: center;
      margin-left: 10px;
      padding: 0 10px;
      &__input{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
      }
    }
  }
  &-bottom{
    margin: 0 50px;
    display: flex;
    justify-content: end;
    align-items: center;
  }
  &-dialog{
    &__img{
      width: 1000px;
    }
  }
  &__btn{
    padding: 8px 20px;
    background: #ff7f27;
    color: white;
    font-weight: bold;
    &:hover{
      cursor: pointer;
      opacity: .8;
    }
  }
}
</style>
